<template>
    <div class="carBox" @mouseup="handleMouseUp">
        <el-card ref="left_tree" class="box-card" style="height: calc(100vh - 152px);width: 280px;overflow-y: auto">
            <el-tree :data="projectDivisionData" node-key="value" :current-node-key="pid" :highlight-current="true" ref="my-tree" @node-click="clickPrjectDivision" :default-expanded-keys="openKeys" :expand-on-click-node="false">
                <span slot-scope="{ node }" class="custom-tree-node treeTitle" :title="node.label.split('###')[3]">
                    {{node.label.split('###')[0]}}
                    <span :class="'treeTitleNum'+node.label.split('###')[1]">{{node.label.split('###')[2]}}</span>
                </span>
            </el-tree>
        </el-card>
        <div ref="resizeHandle" class="handle-resize" />
        <div ref="moveDiv" class="handle-resize-h" />
        <el-card class="box-card" style="width: calc(100% - 344px); padding-top: 25px">
            <div class="tabBox">
                <div :class="'tabItem'+(search_type==1?' act':'')" @click="changeSearchType(1)">按孔查询</div>
                <div :class="'tabItem'+(search_type==2?' act':'')" @click="changeSearchType(2)">按报告查询</div>
            </div>
            <div class="mainBody">
                <div class="searchBox" v-if="list_model ==1">
                    <div class="searchGroup" v-if="search_type==1">
                        <label>灌浆类型：</label>
                        <el-select v-model="search_Obj.f_grout_type" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                            <el-option v-for="item in enuObj('grout_type')" :key="'grout_type'+item.key" :label="item.title" :value="item.key"> </el-option>
                        </el-select>
                    </div>
                    <div class="searchGroup">
                        <label>孔号：</label>
                        <el-input v-model="search_Obj.f_hole_code" clearable @keyup.enter.native="doSearch"></el-input>
                    </div>
                    <div class="searchGroup" v-if="search_type==1">
                        <label>加深孔：</label>
                        <el-select v-model="search_Obj.f_is_deepen" clearable placeholder="请选择" @keyup.enter.native="doSearch">
                            <el-option v-for="item in enuObj('yesNo')" :key="'deepen'+item.key" :label="item.title" :value="item.key"> </el-option>
                        </el-select>
                    </div>
                    <div class="searchGroup" v-if="search_type==2">
                        <label>段号：</label>
                        <el-input v-model="search_Obj.f_segment_no" clearable @keyup.enter.native="doSearch" style="width: 100px"></el-input>
                    </div>
                    <div class="searchGroup" v-if="search_type==2">
                        <label>开始时间：</label>
                        <el-date-picker v-model="dateRange" type="daterange" value-format="yyyy-MM-dd" unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            :picker-options="pickerOptions"
                            @change="dateRangeSet1"
                            style="width:320px">
                        </el-date-picker>
                    </div>
                    <div class="searchGroup" v-if="search_type==2">
                        <label>单位注灰量区间：</label>
                        <el-input v-model="search_Obj.ash_volume_unit_min" clearable :disabled="(search_Obj.permeable_rate_min!='' || search_Obj.permeable_rate_max!='')" @keyup.enter.native="doSearch" style="width: 100px"></el-input>
                        <span style="margin: 0 2px">-</span>
                        <el-input v-model="search_Obj.ash_volume_unit_max" clearable :disabled="(search_Obj.permeable_rate_min!='' || search_Obj.permeable_rate_max!='')" @keyup.enter.native="doSearch" style="width: 100px"></el-input>
                    </div>
                    <div class="searchGroup" v-if="search_type==2">
                        <label>透水率区间：</label>
                        <el-input v-model="search_Obj.permeable_rate_min" clearable :disabled="(search_Obj.ash_volume_unit_min!='' || search_Obj.ash_volume_unit_max!='')" @keyup.enter.native="doSearch" style="width: 100px"></el-input>
                        <span style="margin: 0 2px">-</span>
                        <el-input v-model="search_Obj.permeable_rate_max" clearable :disabled="(search_Obj.ash_volume_unit_min!='' || search_Obj.ash_volume_unit_max!='')" @keyup.enter.native="doSearch" style="width: 100px"></el-input>
                    </div>
                    <el-button type="primary" plain @click.native="doSearch">搜索</el-button>
                    <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick" v-if="search_type==1"></Btns>
                </div>
                <div class="dataBox" v-if="list_model ==1 && search_type == 1">
                    <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                        <el-table-column prop="unit_name" label="单元工程" sortable="custom"></el-table-column>
                        <el-table-column prop="unit_code" label="单元编号" sortable="custom" width="150"></el-table-column>
                        <el-table-column prop="hole_code" label="孔号" sortable="custom" width="120"></el-table-column>
                        <el-table-column prop="hole_order" label="孔序" sortable="custom" width="120"></el-table-column>
                        <el-table-column prop="grout_type" label="灌浆类型" sortable="custom" width="120">
                            <template slot-scope="scope" v-if="search_type==1">
                                <span>{{ transEnu(scope.row.grout_type, "grout_type") }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="order_index" label="顺序" sortable="custom" width="100"></el-table-column>
                        <el-table-column label="操作" width="220" align="center">
                            <template slot-scope="scope" v-if="search_type==1">
                                <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" :ignore_ids="',5702,'" @on_btnclk="labelClick" v-if="scope.row.annex_count<=0"></LabBtns>
                                <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" @on_btnclk="labelClick" v-else></LabBtns>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="titleBoxwhr" v-if="list_model ==2 && search_type==1">
                    <h3>
                        孔号：{{work_hole.hole_code}}
                    </h3>
                    <el-button style="margin-left: 50px" @click="back()">返回</el-button>
                </div>
                
                <div class="dataBox" v-if="list_model ==2">
                    <el-table :data="tableData1" v-loading="loading" border stripe>
                        <el-table-column prop="hole_code" label="孔号"></el-table-column>
                        <el-table-column prop="segment_no" label="段号"></el-table-column>
                        <el-table-column prop="report_count" label="报告数量"></el-table-column>
                        <el-table-column label="操作" width="220" align="center">
                            <template slot-scope="scope" v-if="search_type==1">
                                <el-button  size="mini" plain type="primary" @click="infoAll(scope.row)">查看</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="dataBox" v-if="search_type == 2">
                    <el-table :data="tableData" :default-sort="sortData" @sort-change="sortChange" @selection-change="selectChanges" v-loading="loading" border stripe>
                        <el-table-column prop="hole_code" label="孔号" sortable="custom"></el-table-column>
                        <el-table-column prop="segment_no" label="段号" sortable="custom" width="120"></el-table-column>
                        <el-table-column prop="work_type_int" label="作业方式" sortable="custom" width="120">
                            <template slot-scope="scope" v-if="search_type == 2">
                                <span>{{ transEnu(scope.row.work_type_int, "work_type_int") }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="begin_time" label="开始时间" sortable="custom" width="170"></el-table-column>
                        <el-table-column prop="grout_volume" label="注浆量" sortable="custom" width="170"></el-table-column>
                        <el-table-column prop="ash_volume" label="注灰量" sortable="custom" width="170"></el-table-column>
                        <el-table-column prop="ash_volume_unit" label="单位注灰量" sortable="custom" width="170"></el-table-column>
                        <el-table-column prop="permeable_rate" label="透水率" sortable="custom" width="170"></el-table-column>
                        <el-table-column label="操作" width="100" align="center">
                            <template slot-scope="scope" v-if="search_type == 2">
                                <LabBtns :menu_id="menu_id" :row="scope.row" :index="scope.$index" :menus="lab_btns" :ignore_ids="',5702,'" @on_btnclk="labelClick"></LabBtns>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="pageBox" v-if="list_model ==1 || search_type == 2">
                    <el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50]" :current-page="current" :page-size="pagesize" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                </div>
                <Info
                    :report_type="report_type"
                    :hole_id="hole_id"
                    :segment_no="segment_no"
                    :to_report_id="to_report_id"
                    title="查看抽检报告"
                    :isshow="infoshow"
                    @on-close="closeInfoDialog">
                </Info>
                <AnnexList
                    width="600px"
                    :data_id="model_id"
                    :isshow="annexshow"
                    @on-close="closeAnnexDialog">
                </AnnexList>
            </div>
        </el-card>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import LabBtns from "@/components/common/labbtns"
import listutil from "@/libs/listutil"
import { getListData } from '@/api/common'
import { getProjectDivisionTreeData } from '@/api/org'
import { holeReportList, exportExtractReport } from '@/api/workreport'
import Info from "../report_work/info"
import AnnexList from "../report_work/annexlist.vue"

export default {
    name: 'workHoleListForWorReport',
    mixins: [listutil],
    components: {Info, Btns, LabBtns, AnnexList},
    data() {
        return {
            m_name: '灌浆孔-抽检报告',
            menu_id: 5700,
            list_url: "/api/admin/workhole/list",
            search_Obj: {
                f_grout_type: '',
                f_hole_code: '',
                f_is_deepen: '',
                report_type: 3,
                f_report_type: 3,
                f_segment_no: '',
                f_state: 1,
                ash_volume_unit_max: '',
                ash_volume_unit_min: '',
                permeable_rate_max: '',
                permeable_rate_min: '',
            },
            del_Obj:{
                url:'/api/admin/workhole/del',
                data:{
                    ids:''
                }
            },
            enu_name: ['grout_type', 'yesNo', 'work_type_int'],
            grade: 1,
            pid: 0,
            projectDivisionData: [],
            openKeys: [],
            sortData: {
                prop: 'order_index',
                order: 'ascending'
            },
            list_model: 1,
            report_type: 3,
            hole_id: 0,
            segment_no: '',
            to_report_id: 0,
            tableData1: [],
            work_hole: {},
            annexshow: false,
            dateRange: '',
        };
    },
    mounted(){
        this.dragControllerDiv(this.$refs.left_tree.$el, this.$refs.resizeHandle, this.$refs.moveDiv)
    },
    methods: {
        loadOtherData() {
            this.initTree()
        },
        initTree(){
            this.projectDivisionData = []
            getProjectDivisionTreeData(13).then(res=>{
                if(res.code ==1){
                    var treeData = res.data
                    treeData = this.removeEmptyChild(treeData)
                    this.projectDivisionData = treeData
                    this.initOpenKeys()
                }
            })
        },
        initOpenKeys(){//哪些节点要展开
            this.openKeys = this.getAllNodeId(this.openKeys, this.projectDivisionData, 0)
        },
        getAllNodeId (expandedKeys, moduleDataList, level) {
            if(level>1){
                return expandedKeys
            }
            for (let i = 0; i < moduleDataList.length; i++) {
                expandedKeys.push(moduleDataList[i].value)
                if (moduleDataList[i].children) {
                    expandedKeys = this.getAllNodeId(expandedKeys, moduleDataList[i].children, level+1)
                }
            }
            return expandedKeys
        },
        getListData() {
            this.loading = true;
            this.selectData = [];
            if(this.search_type == 1){
                this.list_url = "/api/admin/workhole/list"
            }else if(this.search_type == 2){
                this.list_url = "/api/admin/workreport/list"
            }
            getListData(this.list_url, this.search_Obj).then(res => {
                this.loading = false;
                if (res.code === 1) {
                    this.tableData = res.data.resultList;
                    this.total = res.data.totalRecords;
                    this.grade = res.data.grade
                    this.pid = res.data.pid
                    setTimeout(() => {
                        this.$refs["my-tree"].setCurrentKey(this.pid);
                    }, 1000);
                }
            })
        },
        clickPrjectDivision(data){
            this.pid = data.id
            this.search_Obj.pid = data.id
            this.getListData()
            this.list_model = 1
        },
        info(index, row) {
            if(this.search_type == 1){
                this.list_model = 2
                holeReportList(row.id, this.report_type).then(res=>{
                    if(res.code == 1){
                        this.tableData1 = res.data.list
                        this.work_hole = res.data.work_hole
                        this.qx = res.data.qx
                    }
                })
            }else if(this.search_type == 2){
                this.hole_id = row.hole_id
                this.segment_no = row.segment_no
                this.infoshow = true
                this.to_report_id = row.id
            }
        },
        back(){
            this.list_model = 1
            this.tableData1 = []
            this.work_hole = {}
        },
        infoAll(row){
            this.hole_id = row.hole_id
            this.segment_no = row.segment_no
            this.infoshow = true
        },
        downAnnex(index, row){
            this.model_id = row.id
            this.annexshow = true
        },
        closeAnnexDialog(){
            this.annexshow = false
        },
        downPdf(){
            if (this.selectData.length <= 0) {
                this.$msg("请选择要导出到灌浆孔")
            } else {
                let ids = '';
                for (let data of this.selectData) {
                    if (ids === '') {
                        ids = data.id + "";
                    } else {
                        ids += "," + data.id;
                    }
                }
                exportExtractReport(ids).then(res=>{
                    if(res.code == 1){
                        window.open(res.data)
                    }else{
                        this.$msg(res.msg)
                    }
                })
            }
        },
        changeSearchType(type){
            this.search_type = type
            this.to_report_id = 0
            this.back()
            this.doSearch()
        },
        dateRangeSet1(val){
            if(this.$isNotNull(val)){
                this.search_Obj.f_begin_time_s_date = val[0]
                this.search_Obj.f_begin_time_e_date = val[1]
            }else{
                this.search_Obj.f_begin_time_s_date = ''
                this.search_Obj.f_begin_time_e_date = ''
            }
        },
    }
};
</script>
<style lang="less" scoped>
    .titleBoxwhr {
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
    }
    .carBox .el-card:first-child /deep/ .el-card__body {
        padding: 20px 6px;
    }
</style>